module.exports = __webpack_public_path__ + "img/skillsC-5.7dfe82c1.png";